import { render, staticRenderFns } from "./MessageTextModificationsMatchSetupView.vue?vue&type=template&id=c35177c4&scoped=true&"
import script from "./MessageTextModificationsMatchSetupView.vue?vue&type=script&lang=ts&"
export * from "./MessageTextModificationsMatchSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35177c4",
  null
  
)

export default component.exports